import { render } from "./WarenkorbComponent.vue?vue&type=template&id=62d54868&scoped=true"
import script from "./WarenkorbComponent.vue?vue&type=script&lang=js"
export * from "./WarenkorbComponent.vue?vue&type=script&lang=js"

import "@/styles/WarenkorbComponent.css?vue&type=style&index=0&id=62d54868&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d54868"]])

export default __exports__